import { BarcodeStandardSettings } from 'apps/studio/components/settings/fields/Barcode/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { ReferenceDataPanel } from 'apps/studio/components/settings/fields/Base/referenceData'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Barcode/advanced'


export const BarcodeSettings = [
  FieldSettingsPanel(BarcodeStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
